import styled from 'styled-components'

import { Z_INDEX_QUESTION } from 'src/constants/z-indexes'

export const Wrap = styled.div<{ color: string }>`
  width: 6.4rem;
  height: 6.4rem;
  border-radius: 1.6rem;
  box-shadow: 0 1.2rem 2.4rem 0 rgba(0, 0, 0, 0.11);
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${Z_INDEX_QUESTION};
  flex-shrink: 0;
`

export const Img = styled.img`
  width: 80%;
  height: 80%;
  object-fit: cover;
`
